export const Transactions = (props) => {
  return (
    <div>
      Transactions
    </div>
  )
}